import { cn } from "@/libraries/cn";
import WarningIcon from "@mui/icons-material/Warning";
import Button from "@mui/material/Button";
import { Link } from "@tanstack/react-router";
import dayjs from "dayjs";
import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Typography } from "../text";

interface SubscriptionBarProps extends React.ComponentPropsWithoutRef<"div"> {
	caseLeft: number;
	startOn?: string;
}

const SubscriptionBar: React.FC<SubscriptionBarProps> = ({
	caseLeft,
	startOn,
	className,
	...props
}) => {
	const { t } = useTranslation("common");

	const message = useMemo(() => {
		if (caseLeft > 0) {
			return (
				<Typography fontSize={14} fontWeight={400} className="!text-zinc-950">
					<Trans
						i18nKey="subscriptionBanner.freeCasesLeft"
						ns="common"
						values={{ count: caseLeft }}
						components={{
							1: <b className="!text-zinc-950" />,
						}}
					/>
				</Typography>
			);
		}
		const currentMonthWithDate = dayjs()
			.set("dates", 1)
			.add(1, "months")
			.format("DD MMMM YYYY");

		return (
			<Typography fontSize={14} fontWeight={400} className="!text-zinc-950">
				<Trans
					i18nKey="subscriptionBanner.freeCasesLeftReplenish"
					ns="common"
					values={{ count: caseLeft, date: currentMonthWithDate }}
					components={{
						1: <b className="!text-zinc-950" />,
					}}
				/>
			</Typography>
		);
	}, [caseLeft]);

	return (
		<div className={cn("bg-yellow-100 py-4", className)} {...props}>
			<div className="container flex gap-4">
				<WarningIcon className="!fill-amber-600" />
				<div className="flex flex-col flex-1">
					{message}
					<Link to="/subscription" preload={false}>
						<Button
							variant="text"
							size="medium"
							color="inherit"
							className="!text-zinc-950 !w-fit !font-semibold !px-0 uppercase"
						>
							{t("subscriptionBanner.upgradeNow")}
						</Button>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionBar;
